import React, { useContext } from "react";
import { blockchainUrl } from "../../rbac-consts";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { default as AdminBlockchainUrlDetailsContainer } from "./admin/BlockchainUrlDetailsContainer";

const BlockchainUrlDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={blockchainUrl.ADMIN}
      yes={() => (
        <AdminBlockchainUrlDetailsContainer match={match} />
      )}
    />
  );
};

export default BlockchainUrlDetailsWrapper;